// constants.ts

export const NAME = 'paymentPage';